interface OtpTimerProps {
  timeLeft: number;
  active: boolean;
  onResend: () => void;
}

const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const remainingSeconds = (seconds % 60).toString().padStart(2, '0');
  return `${minutes}:${remainingSeconds}`;
};

const OtpTimer = ({ timeLeft, active, onResend }: OtpTimerProps) => {
  if (active) {
    return <span className="text-[0.75rem] text-gray-500">Resend OTP in {formatTime(timeLeft)}</span>;
  }

  return (
    <button
      type="button"
      onClick={onResend}
      className="text-[0.75rem] font-bold text-[#B89A1D] hover:underline"
    >
      Resend OTP
    </button>
  );
};

export default OtpTimer;
